import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalNotification {
  name: string;
  api_token: string;
}

export interface InternalNotificationDetaiInfor {
  errors: unknown;
  internalNotification: InternalNotification;
  isAuthenticated: boolean;
}

@Module
export default class InternalNotificationDetail
  extends VuexModule
  implements InternalNotificationDetaiInfor
{
  errors = {};
  internalNotification = {} as InternalNotification;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get InternalNotificationDetail() {
    return this.internalNotificationDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.INTERNAL_NOTIFICATION_DETAIL_DATA](InternalNotification) {
    this.internalNotificationDetailData = InternalNotification;
  }
  @Action
  [Actions.INTERNAL_NOTIFICATION_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/thongbaonoibo",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.INTERNAL_NOTIFICATION_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
